import { CrossSellingPointer } from "../../others";
import { RML } from ".";

const crossRmlInsertDialog = () => CrossSellingPointer.waitForVisibleElement('body > div > .media-modal.wp-core-ui .media-frame-router button[role="tab"]:eq(1).active', RML, "insert-dialog");

export { crossRmlInsertDialog };